import { ISelectOption } from 'app/interfaces/ISelectOption';

export type AdditionalProperties = 'MAXERRORS' | 'DATEFORMAT' | 'IDENTITY_INSERT';
export const knownAdditionalProperties: Record<AdditionalProperties, AdditionalProperties> = {
    MAXERRORS: 'MAXERRORS',
    DATEFORMAT: 'DATEFORMAT',
    IDENTITY_INSERT: 'IDENTITY_INSERT'
};

export const knownAdditionalPropertiesOptions: Array<ISelectOption<AdditionalProperties>> = [
    {
        label: 'MAXERRORS',
        value: knownAdditionalProperties.MAXERRORS
    },
    {
        label: 'DATEFORMAT',
        value: knownAdditionalProperties.DATEFORMAT
    },
    {
        label: 'IDENTITY_INSERT',
        value: knownAdditionalProperties.IDENTITY_INSERT
    }
];

export const identityInsertOptions: Array<ISelectOption<string>> = [
    {
        label: '\'OFF\'',
        value: '\'OFF\''
    },
    {
        label: '\'ON\'',
        value: '\'ON\''
    }
];

export const dateFormatOptionValues = {
    MDY: '\'mdy\'',
    DMY: '\'dmy\'',
    YMD: '\'ymd\'',
    YDM: '\'ydm\'',
    MYD: '\'myd\'',
    DYM: '\'dym\''
};

export type DateFormatOptionValue = '\'mdy\'' | '\'dmy\'' | '\'ymd\'' | '\'ydm\'' | '\'myd\'' | '\'dym\'';

export const dateFormatOptions: Array<ISelectOption<DateFormatOptionValue>> = [
    {
        label: stringResources.CopyCommand_DateFormat_Default,
        value: undefined
    },
    {
        label: dateFormatOptionValues.DMY as DateFormatOptionValue,
        value: dateFormatOptionValues.DMY as DateFormatOptionValue
    },
    {
        label: dateFormatOptionValues.DYM as DateFormatOptionValue,
        value: dateFormatOptionValues.DYM as DateFormatOptionValue
    },
    {
        label: dateFormatOptionValues.MDY as DateFormatOptionValue,
        value: dateFormatOptionValues.MDY as DateFormatOptionValue
    },
    {
        label: dateFormatOptionValues.MYD as DateFormatOptionValue,
        value: dateFormatOptionValues.MYD as DateFormatOptionValue
    },
    {
        label: dateFormatOptionValues.YDM as DateFormatOptionValue,
        value: dateFormatOptionValues.YDM as DateFormatOptionValue
    },
    {
        label: dateFormatOptionValues.YMD as DateFormatOptionValue,
        value: dateFormatOptionValues.YMD as DateFormatOptionValue
    }
];
